import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const initialState = {
    url: "",
    highways: [],
    restAreas: [],
    gasStationTypes: [],
    objects: [],
    filters: {},
    cameras: [],
    tollPlacesType: [],
    tollStations: [],
    modal: {},
    markers: {},
    backupMarkers: {},
    highwayMarkers: [],
    codebook: {},
    tollCoordinates: [],
    extraordinary: [],
    tollInfo: {},
    mapZoom: null,
    tollPoints: [],
    fitBoundsFlag: false,
    showExtraordinary: true,
    selectedCondition: null,
};

const store = new Vuex.Store({
    state: initialState,

    mutations: {
        setData(state, payload) {
            let { name, data } = payload;
            Vue.set(state, `${name}`, data);
        },

        clearAllFilters(state) {
            Vue.set(state, "filters", {});
            Vue.set(state, "markers", {});
            Vue.set(state, "highwayMarkers", []);
            Vue.set(state, "tollCoordinates", []);
            Vue.set(state, "tollInfo", {});
            Vue.set(state, "tollPoints", []);
            Vue.set(state, "fitBoundsFlag", true);
        },

        resetRestAreaFilters(state) {
            let stateFilters = JSON.parse(JSON.stringify(state.filters));

            stateFilters["restAreas"] = [];

            Vue.set(state, "filters", stateFilters);
        },

        removeFilter(state, payload) {
            let stateFilters = JSON.parse(JSON.stringify(state.filters));
            if (payload.id) {
                stateFilters[payload.category] = stateFilters[
                    payload.category
                ].filter((el) => el !== payload.id);
                if (!stateFilters[payload.category].length) {
                    delete stateFilters[payload.category];
                }
            } else {
                delete stateFilters[payload.category];
            }

            //state.filters.filter(el => (el.id !== payload.id && el.name !== payload.name))
            Vue.set(state, "filters", stateFilters);
        },

        addFilter(state, payload) {
            // console.log('mutation payload', payload);
            let stateFilters = JSON.parse(JSON.stringify(state.filters));
            //state.filters.slice()
            if (payload.id) {
                if (!stateFilters[payload.category]) {
                    stateFilters[payload.category] = [];
                }
                stateFilters[payload.category].push(payload.id);
            } else {
                stateFilters[payload.category] = 1;
            }
            Vue.set(state, "filters", stateFilters);
        },

        setModal(state, payload) {
            Vue.set(state, "modal", payload);
        },

        setMarkers(state, payload) {
            let stateMarkers = JSON.parse(JSON.stringify(state.markers));
            if (!stateMarkers[payload.category]) {
                stateMarkers[payload.category] = [];
            }
            stateMarkers[payload.category] = payload.data.map((marker) => ({
                ...marker,
                category: payload.category,
            }));

            Vue.set(state, "markers", stateMarkers);
            Vue.set(state, "backupMarkers", stateMarkers);
        },

        setBackupMarkers(state, payload) {
            let stateMarkers = JSON.parse(JSON.stringify(state.markers));
            if (!stateMarkers[payload.category]) {
                stateMarkers[payload.category] = [];
            }
            stateMarkers[payload.category] = payload.data.map((marker) => ({
                ...marker,
                category: payload.category,
            }));

            Vue.set(state, "backupMarkers", stateMarkers);
        },

        removeMarkers(state, payload) {
            let stateMarkers = JSON.parse(JSON.stringify(state.markers));
            delete stateMarkers[payload.category];
            if (!(state.filters && state.filters["highway"])) {
                Vue.set(state, "highwayMarkers", []);
            }

            //state.filters.filter(el => (el.id !== payload.id && el.name !== payload.name))
            Vue.set(state, "markers", stateMarkers);
        },

        setHighwayMarkers(state, payload) {
            //@TODO move highwayFilters to actions since this info is stored inside getters?
            let highwayFilters =
                state.filters && state.filters.highways
                    ? state.filters.highways.length
                    : 0;

            if (highwayFilters) {
                Vue.set(state, "markers", {});
                Vue.set(state, "highwayMarkers", payload);
            } else {
                // handle user unselect highways and set response to markers ?
            }
        },

        removeHighwayMarkers(state) {
            Vue.set(state, "highwayMarkers", []);
            if (Object.keys(state.filters).length) {
                Vue.set(state, "markers", state.backupMarkers);
            }
        },

        //   removeHighwayMarkers(state, payload){
        //     Vue.set(state, 'highwayMarkers', [])
        //   },
        setCodeBook(state, payload) {
            let keys = Object.keys(payload);
            keys.forEach((key) => {
                Vue.set(state, key, payload[key].data);
            });
            Vue.set(state, "codebook", payload);
        },

        setExtraordinary(state, payload) {
            let keys = Object.keys(payload);
            keys.forEach((key) => {
                Vue.set(state, key, payload[key].data);
            });
            Vue.set(state, "extraordinary", payload);
        },
        setTollStations(state, payload) {
            Vue.set(state, "tollStations", payload);
        },

        setUrl(state, payload) {
            Vue.set(state, "url", payload);
        },

        setTollCoordinates(state, payload) {
            let coords = payload.length ? [payload] : [];
            Vue.set(state, "tollCoordinates", coords);
        },

        setTollInfo(state, payload) {
            Vue.set(state, "tollInfo", payload);
        },

        zoomUpdate(state, payload) {
            Vue.set(state, "mapZoom", payload);
        },

        setTollPoints(state, payload) {
            Vue.set(state, "tollPoints", payload);
        },

        stopFitBounds(state) {
            Vue.set(state, "fitBoundsFlag", false);
        },
    },

    actions: {},

    getters: {
        filters: (state) => state.filters,
        highways: (state) => state.highways,
        modal: (state) => state.modal,

        restAreas: (state) => {
            let filtered = state.restAreas.filter(
                (area) =>
                    !(
                        area == "closed" ||
                        area == "under_construction" ||
                        area == "park" ||
                        area == "camp"
                    )
            );
            return filtered;
        },

        objects: (state) => state.objects,
        cameras: (state) => state.cameras,
        url: (state) => state.url,
        markers: (state) => state.markers,
        codebook: (state) => state.codebook,
        extraordinary: (state) => state.extraordinary,
        highwayMarkers: (state) => state.highwayMarkers,
        gasStationTypes: (state) => state.gasStationTypes,
        vehicleCategory: (state) => state.vehicleCategory,
        tollPlacesType: (state) => [
            state.tollPlacesType[1],
            state.tollPlacesType[0],
            state.tollPlacesType[2],
        ],
        tollStations: (state) => state.tollStations,
        tollCoordinates: (state) => state.tollCoordinates,
        tollInfo: (state) => state.tollInfo,
        tollPoints: (state) => state.tollPoints,
        fitBoundsFlag: (state) => state.fitBoundsFlag,

        filtersCount: (state) => {
            let count = 0;
            let keys = Object.keys(state.filters);
            if (keys.length) {
                keys.forEach((key) => {
                    let length =
                        typeof state.filters[key] == "object"
                            ? state.filters[key].length
                            : 1;
                    return (count = count + length);
                });
            }
            return count;
        },

        filtersNotHighway: (state) => {
            let count = 0;
            let keys = Object.keys(state.filters);
            if (keys.length) {
                keys.forEach((key) => {
                    if (key !== "highways") {
                        let length =
                            typeof state.filters[key] == "object"
                                ? state.filters[key].length
                                : 1;
                        return (count = count + length);
                    }
                });
            }
            return count;
        },

        highwayFilters: (state) => {
            let count =
                state.filters && state.filters.highways
                    ? state.filters.highways.length
                    : 0;
            return count;
        },

        markersCount: (state) => {
            let keys = Object.keys(state.markers);
            return keys.length;
        },

        highwayMarkersCount: (state) => {
            let keys = Object.keys(state.highwayMarkers);
            return keys.length;
        },

        mapZoom: (state) => {
            return state.mapZoom;
        },

        showExtraordinary: (state) => state.showExtraordinary,
        selectedCondition: (state) => state.selectedCondition,
    },
});

export default store;
